module.exports = __webpack_public_path__ + "173cfccf9bff27601c32cfdc67ab1b3c.png";